export default __webpack_public_path__ + "static/media/totalorders.3643d87c.svg";